import React, { useState, useEffect } from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import $ from "jquery";
function Calendar(props) {
  // debugger
  const [startDate, setStartDate] = useState(new Date());
  const [dateOnchange, setDateOnchange] = useState(false);

  let EuDateFormate = process.env.REACT_APP_UNITS_SYSTEM;

  // document.querySelectorAll('.react-date-picker__inputGroup__year').forEach(el => { el.setAttribute('maxlength', 4) el.setAttribute('max', 9999) })
  useEffect(() => {
    if (props.todaydateSelected === "") {
      if (props.nextWeek === 0 && props.previousWeek === 0) {
        let date3 = startDate;
        let day = date3.getDay();
        setDateOnchange(false);
        if (day === 0) {
          day = 7;
        }
        if (props.changedate !== -1) {
          if (day < props.changedate + 1) {
            let diff = props.changedate + 1 - day;
            let date = date3.setDate(date3.getDate() + diff);
            setStartDate(new Date(date));
          }
          if (props.changedate + 1 < day) {
            let diff = day - (props.changedate + 1);
            let date = date3.setDate(date3.getDate() - diff);
            setStartDate(new Date(date));
          }
          let dd = String(startDate.getDate()).padStart(2, "0");
          let mm = String(startDate.getMonth() + 1).padStart(2, "0"); //January is 0!
          let yyyy = startDate.getFullYear();
          let date;
          if (EuDateFormate === "metric") {
            date = dd + "/" + mm + "/" + yyyy;
          } else {
            date = mm + "/" + dd + "/" + yyyy;
          }

          props.dateCallback(date);
        } else {
          let dd = String(startDate.getDate()).padStart(2, "0");
          let mm = String(startDate.getMonth() + 1).padStart(2, "0"); //January is 0!
          let yyyy = startDate.getFullYear();
          let date;
          if (EuDateFormate === "metric") {
            date = dd + "/" + mm + "/" + yyyy;
          } else {
            date = mm + "/" + dd + "/" + yyyy;
          }

          props.dateCallback(date, day);
        }
        // if (props.nextPreviousWeak === 'next') {
        //     if (day === props.changedate + 1) {
        //         let date = date3.setDate(date3.getDate() + 7);
        //         setStartDate(new Date(date))
        //     }
        // }
        // if (props.nextPreviousWeak === 'previous') {
        //     if (day === props.changedate + 1) {
        //         let date = date3.setDate(date3.getDate() - 7);
        //         setStartDate(new Date(date))
        //     }
        // }
      } else {
        let date3 = startDate;
        let day = date3.getDay();
        if (day === 0) {
          day = 7;
        }
        setDateOnchange(false);
        if (day < props.changedate + 1) {
          let diff = props.changedate + 1 - day;
          let date = date3.setDate(date3.getDate() + diff);
          setStartDate(new Date(date));
        }
        if (props.changedate + 1 < day) {
          let diff = day - (props.changedate + 1);
          let date = date3.setDate(date3.getDate() - diff);
          setStartDate(new Date(date));
        }
        let dd = String(startDate.getDate()).padStart(2, "0");
        let mm = String(startDate.getMonth() + 1).padStart(2, "0"); //January is 0!
        let yyyy = startDate.getFullYear();
        let date;
        if (EuDateFormate === "metric") {
          date = dd + "/" + mm + "/" + yyyy;
        } else {
          date = mm + "/" + dd + "/" + yyyy;
        }

        props.dateCallback(date);
        props.dateCallback(date);

        if (props.nextWeek > 0) {
          if (day === props.changedate + 1) {
            let date = date3.setDate(date3.getDate() + 7);
            setStartDate(new Date(date));
            nextPreviousWeek();
          }
        }
        if (props.previousWeek > 0) {
          if (day === props.changedate + 1) {
            let date = date3.setDate(date3.getDate() - 7);
            setStartDate(new Date(date));
            nextPreviousWeek();
          }
        }

        // })
      }
    } else {
      // let startDate = new Date()
      // let dd = String(startDate.getDate()).padStart(2, '0');
      // let mm = String(startDate.getMonth() + 1).padStart(2, '0'); //January is 0!
      // let yyyy = startDate.getFullYear();
      // var date = mm + '/' + dd + '/' + yyyy;
      props.dateCallback("");
      setStartDate(new Date());
    }
  }, [
    props.todaydateSelected,
    props.changedate,
    props.previousWeek,
    props.nextWeek,
  ]);

  const nextPreviousWeek = () => {
    let dd = String(startDate?.getDate()).padStart(2, "0");
    let mm = String(startDate?.getMonth() + 1).padStart(2, "0"); //January is 0!
    let yyyy = startDate?.getFullYear();
    let date;
    if (EuDateFormate === "metric") {
      date = dd + "/" + mm + "/" + yyyy;
    } else {
      date = mm + "/" + dd + "/" + yyyy;
    }

    props.dateCallback(date, 1);
    // props.dateCallback(date,0)
  };

  if (dateOnchange === true) {
    let day = startDate?.getDay();
    let dd = String(startDate?.getDate()).padStart(2, "0");
    let mm = String(startDate?.getMonth() + 1).padStart(2, "0"); //January is 0!
    let yyyy = startDate?.getFullYear();
    var date;
    if (EuDateFormate === "metric") {
      date = dd + "/" + mm + "/" + yyyy;
    } else {
      date = mm + "/" + dd + "/" + yyyy;
    }
    let selectedDateStr = "NextPreviousBlank";
    props.dateCallback(date, day, selectedDateStr);
  }
  localStorage.setItem("selecteddate", startDate);

  $(
    ".react-date-picker__inputGroup__year,.react-date-picker__inputGroup__month,.react-date-picker__inputGroup__day"
  ).on("keydown", function (event) {
    var key = event.keyCode || event.charCode;
    if (key == 8 || key == 46) return false;
  });

  const limitKeypress = (event) => {
    event.preventDefault();
    return false;
  };

  return (
    <div>
      <DatePicker
        onKeyPress={(event) => limitKeypress(event)}
        onChange={(date) => (setStartDate(date), setDateOnchange(true))}
        value={startDate}
        format={EuDateFormate === "metric" ? "dd/MM/yyyy" : "MM/dd/yyyy"}
      />

      <div
        style={{ position: "absolute", right: "5px", top: "7px", zIndex: "0" }}
      >
        <img src={require("assets/calendar.svg").default} />
      </div>
    </div>
  );
}
export default Calendar;
